import React from 'react';
import Backend from '../../Layouts/Backend';
import { Alert, Button, NavButton } from '../../UI/Common';
import Datagrid from '../../UI/Datagrid';
import { useTranslation } from 'react-i18next';

export default ({ datagridProps, ...props }) => {
  const { t } = useTranslation('app');
  const { legacyUserId } =
    JSON.parse(localStorage.getItem('userProfile')) || {};
  const customExport = [
    {
      name: 'Export to CSV',
      action: () => props.onExport('csv'),
    },
    {
      name: 'Export to PDF',
      action: () => props.onExport('pdf'),
    },
  ];
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={props.errors} />
        <Datagrid
          datagridProps={{
            keyField: 'departmentName',
            data: props.statistics,
            loading: props.loading,
            ...datagridProps,
          }}
          // exportProps={{
          //   fileName: 'MKTMonitors',
          // }}
          customExportProps={customExport}
        />
        <div className="d-flex flex-row">
          <Button
            loading={props.isSending}
            onClick={props.onSendLicenseEmail}
            classes="m-1"
          >
            {t('Send License Email')}
          </Button>
          {legacyUserId === 1 ? (
            <NavButton
              to="/system-admin-dashboard/modify-email-schedule"
              classes="m-1"
            >
              {t('Modify Email Schedule')}
            </NavButton>
          ) : null}
        </div>
      </div>
    </Backend>
  );
};
